import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "color", "label"];
import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { deprecate } from '../../utils/deprecate';
import { pxToRem } from '../../utils/size-to-rem';
import { icons } from './iconTypes';
import { LegacyIcon } from './LegacyIcon';
export var rtlIcons = {
  'car-features': true,
  'media-next': true,
  'media-previous': true,
  'navigation-arrowback': true,
  'navigation-chevronback': true,
  'navigation-chevronforward': true,
  'office-otherfacilityfaults': true,
  externallink: true,
  list: true,
  nohiddencost: true,
  ownersmanual: true,
  share: true
};
var legacyIcons = {
  account: true,
  email: true,
  search: true,
  facebook: true,
  twitter: true,
  youtube: true,
  instagram: true,
  linkedin: true,
  globe: true,
  pinterest: true,
  youku: true,
  wechat: true,
  vkontakte: true,
  weibo: true
};
export var getIconSrcUrl = function getIconSrcUrl(_ref) {
  var color = _ref.color,
      name = _ref.name,
      size = _ref.size,
      theme = _ref.theme;
  var isRTL = theme.direction === 'rtl';
  var iconType = "".concat(name, "-").concat(size);
  var path = "".concat(theme.iconsPath).concat(iconType).concat(isRTL && rtlIcons[name] ? '-rtl' : '');
  var themeMode = theme.name === 'volvo' ? 'light' : 'dark';
  return "".concat(path, ".svg#").concat(themeMode, "-").concat(color);
};
export function Icon(_ref2) {
  var type = _ref2.type,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'primary' : _ref2$color,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? '' : _ref2$label,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useFela = useFela(),
      theme = _useFela.theme,
      css = _useFela.css;

  if (legacyIcons[type]) {
    deprecate('The old set of icons are deprecated and will be removed in version 3.0.0. Please use the new fixed size icons instead.', true);
    return /*#__PURE__*/React.createElement(LegacyIcon, _extends({
      type: type
    }, props));
  }

  var size = Number(type.split('-').pop());
  var name = type.replace("-".concat(size), '');
  var iconSrc = getIconSrcUrl({
    theme: theme,
    color: color,
    name: name,
    size: size
  });
  return /*#__PURE__*/React.createElement("img", {
    width: size,
    height: size,
    src: iconSrc,
    role: label ? null : 'presentation',
    alt: label,
    className: css({
      width: pxToRem(size),
      height: pxToRem(size)
    })
  });
}
Icon.propTypes = {
  // babel-plugin-transform-react-remove-prop-types cleans up properly, even with references
  type: PropTypes.oneOf(icons).isRequired,
  color: PropTypes.oneOf(['primary', 'secondary', 'inverted', 'alert', 'action']),
  label: PropTypes.string
};